/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import Button from "../button";
import Typography from "../typography";
import { Heading } from "../typography/Heading";
import { JobPost } from "@/types/schema";
import {
  capitalizeFirstLetter,
  getJobPostCategoryColor,
  removeUnderscoreAndSpaceText,
} from "@/lib/utils";

// components/JobCard.tsx
interface JobProps {
  job: JobPost;
}

export default function JobCard({ job }: JobProps) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-center justify-between bg-white p-6 rounded-14 shadow-sm mb-4 border-l-[14px] max-w-736px w-full  "
      style={{
        borderLeftColor: `${getJobPostCategoryColor(job.job_category)}59`,
      }}
    >
      <div className="space-y-2">
        <Heading
          className=" mb-0.5"
          as={"h5"}
          size="h5"
          weight={400}
          color="black"
        >
          {job.title}
        </Heading>
        <Typography size="body1" weight={400} color="neoGray">
          {job.salary_range}
        </Typography>

        <div className="flex flex-wrap gap-4 pt-2 text-sm text-gray-500">
          <div className="flex items-center gap-1">
            <img
              src="/icons/time-16.svg"
              alt="Job type"
              className="w-4 h-4 opacity-60"
            />
            {removeUnderscoreAndSpaceText(job.job_type)}
          </div>

          <div className="flex items-center gap-1">
            <img
              src="/icons/location-16.svg"
              alt="Location"
              className="w-4 h-4 opacity-60"
            />
            {`${job.location}, ${capitalizeFirstLetter(job.job_mode)}`}
          </div>
        </div>
      </div>

      {/* <button className="mt-6 md:mt-0 bg-gray-100 hover:bg-gray-200 text-blue-600 px-6 py-2 rounded-md font-medium transition-colors text-center self-start">
        See details
      </button> */}
      <Link
        href={`/careers/${job.job_slug}`}
        className="self-start mt-6 md:mt-0  w-full md:w-fit"
      >
        <Button
          width="parentWidth"
          intent="secondary"
          textWeight={400}
          label="See details"
          className=" text-primary"
        />
      </Link>
    </div>
  );
}
